/**
 * Mobile sticky add-to-cart bar for Dad Brand PDPs.
 * Toggle: Theme settings → Product pages → Sticky add to cart bar.
 */
(function () {
  'use strict';

  var MOBILE_MQ = window.matchMedia('(max-width: 768px)');
  var PRODUCT_PATH = /^\/products\//;

  function qs(root, sel) {
    return (root || document).querySelector(sel);
  }

  function parseData() {
    var el = document.getElementById('dadbrand-sticky-atc-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (_e) {
      return null;
    }
  }

  function isMysteryOrModalOpen() {
    if (document.body.classList.contains('modal-opened')) return true;
    if (document.querySelector('modal-box.active')) return true;
    var mystery = document.querySelector('[id*="mystery" i], [class*="mystery-discount" i], [class*="mystery_discount" i]');
    if (mystery) {
      var r = mystery.getBoundingClientRect();
      if (r.width > 0 && r.height > 0 && r.bottom > window.innerHeight * 0.5) return true;
    }
    return false;
  }

  function init() {
    var data = parseData();
    var bar = document.getElementById('dadbrand-sticky-atc');
    if (!data || !bar || !PRODUCT_PATH.test(location.pathname)) return;
    if (!MOBILE_MQ.matches) {
      bar.remove();
      return;
    }

    var mainAtc = document.querySelector('.product--add-to-cart-button');
    var productPage = document.querySelector('product-page.product');
    var productForm = document.querySelector('.product--add-to-cart-form form[data-type="add-to-cart-form"]');
    var productVariants = document.querySelector('product-variants');
    var gallery = document.querySelector('.box__product-gallery, .product-gallery');

    var btn = qs(bar, '[data-sticky-atc-submit]');
    var btnLabel = qs(bar, '[data-sticky-atc-btn-label]');
    var spinner = qs(bar, '[data-sticky-atc-spinner]');
    var priceEl = qs(bar, '[data-sticky-atc-price]');
    var compareEl = qs(bar, '[data-sticky-atc-compare]');
    var imageEl = qs(bar, '[data-sticky-atc-image]');
    var errorEl = qs(bar, '[data-sticky-atc-error]');
    var liveEl = qs(bar, '[data-sticky-atc-live]');
    var scrollBtn = qs(bar, '[data-sticky-atc-scroll]');

    var state = {
      loaded: false,
      scrolledPastMainAtc: false,
      cartOpen: false,
      modalOpen: false,
      inSuccess: false,
      adding: false
    };

    function getVariantId() {
      if (!productForm) return data.variantId;
      var input = productForm.querySelector('input[name="id"]');
      return input ? parseInt(input.value, 10) : data.variantId;
    }

    function needsVariantSelection() {
      return !!(productForm && productForm.classList.contains('unavailable-variant'));
    }

    function isSoldOut() {
      if (needsVariantSelection()) return false;
      return !!(mainAtc && mainAtc.classList.contains('disabled'));
    }

    function mainAtcLabel() {
      var textEl = document.querySelector('[data-js-product-add-to-cart-text]');
      return textEl ? textEl.textContent.trim() : '';
    }

    function stickyBtnLabel() {
      if (isSoldOut()) return 'SOLD OUT';
      if (needsVariantSelection()) {
        var mainLabel = mainAtcLabel();
        if (mainLabel) return mainLabel.toUpperCase();
        return (data.chooseOptionsLabel || 'Choose options').toUpperCase();
      }
      return 'ADD TO CART';
    }

    function scrollToVariantPicker() {
      var picker = document.querySelector('product-variants') || document.querySelector('[data-js-product-variant]');
      if (!picker) return;
      var top = picker.getBoundingClientRect().top + window.scrollY - 16;
      window.scrollTo({ top: top, behavior: 'smooth' });
      window.setTimeout(function () {
        var focusTarget = picker.querySelector(
          '[data-js-product-variant-container="select"], ' +
          '[data-js-product-variant-container="radio"] .product-variant__input:not(:checked), ' +
          '[data-js-product-variant-container="radio"] .product-variant__input:checked'
        );
        if (focusTarget && typeof focusTarget.focus === 'function') {
          focusTarget.focus({ preventScroll: true });
        }
      }, 350);
    }

    function syncFromDom() {
      if (state.inSuccess) return;
      var priceBlock = document.querySelector('[data-js-product-price-original]');
      var compareBlock = document.querySelector('[data-js-product-price-compare]');
      if (priceBlock) priceEl.textContent = priceBlock.textContent.trim();
      if (compareBlock && compareBlock.textContent.trim()) {
        compareEl.textContent = compareBlock.textContent.trim();
        compareEl.classList.remove('dadbrand-sticky-atc__compare--hidden');
      } else {
        compareEl.textContent = '';
        compareEl.classList.add('dadbrand-sticky-atc__compare--hidden');
      }

      var soldOut = isSoldOut();
      var chooseOptions = needsVariantSelection();
      btn.disabled = soldOut || state.adding;
      btn.classList.toggle('dadbrand-sticky-atc__btn--sold-out', soldOut);
      btn.classList.toggle('dadbrand-sticky-atc__btn--choose', chooseOptions);
      btnLabel.textContent = stickyBtnLabel();

      if (chooseOptions) {
        btn.setAttribute('aria-label', stickyBtnLabel() + ' for ' + data.productTitle);
      } else if (soldOut) {
        btn.setAttribute('aria-label', data.productTitle + ' is sold out');
      } else {
        btn.setAttribute('aria-label', 'Add ' + data.productTitle + ' to cart, ' + priceEl.textContent.trim());
      }
    }

    function syncVariantImage(variant) {
      if (!variant || !imageEl) return;
      if (variant.featured_image && variant.featured_image.src) {
        imageEl.src = variant.featured_image.src;
        return;
      }
      if (productPage && variant.featured_media && variant.featured_media.id) {
        var slide = productPage.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"] img');
        if (slide && slide.src) imageEl.src = slide.src;
      }
    }

    function shouldShow() {
      if (!state.loaded || !MOBILE_MQ.matches) return false;
      if (!PRODUCT_PATH.test(location.pathname)) return false;
      if (state.inSuccess) return true;
      if (!state.scrolledPastMainAtc) return false;
      if (state.cartOpen || state.modalOpen || isMysteryOrModalOpen()) return false;
      return true;
    }

    function setBarHeightVar() {
      var wasHidden = bar.hidden;
      bar.hidden = false;
      bar.classList.remove('is-visible');
      var height = bar.offsetHeight || 76;
      if (wasHidden) bar.hidden = true;
      document.documentElement.style.setProperty('--dadbrand-sticky-atc-height', height + 'px');
    }

    function renderVisibility() {
      state.modalOpen = isMysteryOrModalOpen();
      var show = shouldShow();
      bar.hidden = !show;
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.classList.toggle('is-visible', show);
    }

    function updateScrollPastState(entry) {
      if (!mainAtc) {
        state.scrolledPastMainAtc = false;
        renderVisibility();
        return;
      }
      var rect = entry ? entry.boundingClientRect : mainAtc.getBoundingClientRect();
      state.scrolledPastMainAtc = rect.bottom <= 0;
      renderVisibility();
    }

    setBarHeightVar();

    if (mainAtc) {
      new IntersectionObserver(function (entries) {
        updateScrollPastState(entries[0]);
      }, { threshold: 0, rootMargin: '0px' }).observe(mainAtc);
      updateScrollPastState(null);
    } else {
      state.scrolledPastMainAtc = false;
    }

    if (productVariants) {
      productVariants.addEventListener('VARIANT_CHANGE', function (e) {
        syncFromDom();
        syncVariantImage(e.target.currentVariant);
      });
    }

    MOBILE_MQ.addEventListener('change', function (e) {
      if (!e.matches) {
        bar.remove();
        return;
      }
      setBarHeightVar();
      updateScrollPastState(null);
    });

    window.addEventListener('resize', setBarHeightVar, { passive: true });

    ['cart:open', 'rebuy:smartcart.show'].forEach(function (ev) {
      document.addEventListener(ev, function () {
        state.cartOpen = true;
        renderVisibility();
      });
    });

    ['cart:close', 'rebuy:smartcart.hide'].forEach(function (ev) {
      document.addEventListener(ev, function () {
        state.cartOpen = false;
        renderVisibility();
      });
    });

    document.addEventListener('modal:open', function () {
      state.modalOpen = true;
      renderVisibility();
    });

    document.addEventListener('modal:close', function () {
      state.modalOpen = false;
      renderVisibility();
    });

    scrollBtn.addEventListener('click', function () {
      var target = gallery || productPage;
      if (!target) return;
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY, behavior: 'smooth' });
    });

    function setLoading(on) {
      state.adding = on;
      btn.classList.toggle('is-loading', on);
      btn.disabled = on || isSoldOut();
      btnLabel.hidden = on;
      spinner.hidden = !on;
    }

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.hidden = false;
      setTimeout(function () {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }, 3000);
    }

    function refreshCartSections() {
      var cartForm = document.getElementById('AjaxCartForm');
      if (window.refreshCart) {
        try {
          window.refreshCart();
        } catch (_e) { /* ignore */ }
      }
      if (!cartForm) {
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
            });
          })
          .catch(function () { /* ignore */ });
      }
      return fetch('?section_id=helper-cart')
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var cartSubtotal = document.getElementById('AjaxCartSubtotal');
          cartForm.innerHTML = doc.getElementById('AjaxCartForm').innerHTML;
          if (typeof cartForm.ajaxifyCartItems === 'function') cartForm.ajaxifyCartItems();
          document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
            var count = doc.querySelector('#AjaxCartForm [data-cart-count]');
            if (count) el.textContent = count.textContent;
          });
          if (cartSubtotal && doc.getElementById('AjaxCartSubtotal')) {
            cartSubtotal.innerHTML = doc.getElementById('AjaxCartSubtotal').innerHTML;
          }
        })
        .catch(function () { /* ignore */ });
    }

    btn.addEventListener('click', function () {
      if (btn.disabled || state.adding || isSoldOut()) return;

      if (needsVariantSelection()) {
        scrollToVariantPicker();
        showError('Select options to add to cart');
        if (liveEl) liveEl.textContent = 'Select product options before adding to cart';
        return;
      }

      var variantId = getVariantId();
      if (!variantId) {
        scrollToVariantPicker();
        showError('Select options to add to cart');
        return;
      }

      setLoading(true);
      errorEl.hidden = true;

      fetch((window.KROWN && KROWN.settings.routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: 'id=' + encodeURIComponent(variantId) + '&quantity=1'
      })
        .then(function (response) { return response.json(); })
        .then(function (response) {
          if (response.status === 422) throw new Error('add failed');
          return refreshCartSections().then(function () { return response; });
        })
        .then(function (response) {
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: response }));
          document.dispatchEvent(new CustomEvent('cart:refresh'));

          var sr = document.getElementById('screen-reader-info');
          var msg = (window.KROWN && KROWN.settings.locales.cart_announcement) || 'Item added to cart';
          if (liveEl) liveEl.textContent = msg;
          if (sr) sr.innerText = msg;

          state.inSuccess = true;
          setLoading(false);
          btn.classList.add('is-success');
          btnLabel.textContent = '\u2713 ADDED';
          btnLabel.hidden = false;
          spinner.hidden = true;
          renderVisibility();

          setTimeout(function () {
            state.inSuccess = false;
            btn.classList.remove('is-success');
            if (liveEl) liveEl.textContent = '';
            if (sr) sr.innerText = '';
            syncFromDom();
            renderVisibility();
          }, 1500);
        })
        .catch(function () {
          setLoading(false);
          syncFromDom();
          showError("Couldn't add \u2014 try again");
        });
    });

    syncFromDom();

    function onLoadReady() {
      state.loaded = true;
      setBarHeightVar();
      renderVisibility();
    }

    if (document.readyState === 'complete') onLoadReady();
    else window.addEventListener('load', onLoadReady, { once: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
